import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface ErroFoody {
    data: string
    operacao: string
    mensagem: string
}

export interface IntegracaoFoodyDados {
    token: string
    erros: ErroFoody[]
}

export interface TesteIntegracaoResposta {
    ativa: boolean
    mensagem: string
    erros: ErroFoody[]
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterIntegracaoFoody = async function (
    authorization: string
): Promise<IntegracaoFoodyDados | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<IntegracaoFoodyDados>>("fooddelivery/ObterIntegracaoFoody", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<IntegracaoFoodyDados>(response, "ObterIntegracaoFoody")
    } catch (error) {
        RegistrarLogErro(error, "ObterIntegracaoFoody", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarTokenFoody = async function (
    authorization: string,
    token: string
): Promise<{ token: string } | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<{ token: string }>>(
                "fooddelivery/SalvarTokenFoody",
                { token },
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<{ token: string }>(response, "SalvarTokenFoody")
    } catch (error) {
        RegistrarLogErro(error, "SalvarTokenFoody", token)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const testarIntegracaoFoody = async function (
    authorization: string
): Promise<TesteIntegracaoResposta | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<TesteIntegracaoResposta>>(
                "fooddelivery/TestarIntegracaoFoody",
                {},
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<TesteIntegracaoResposta>(response, "TestarIntegracaoFoody")
    } catch (error) {
        RegistrarLogErro(error, "TestarIntegracaoFoody", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const limparErrosFoody = async function (authorization: string): Promise<void | ErroApi> {
    try {
        const response = await api
            .delete<{ codErro?: number; mensagem?: string } | null>(
                "fooddelivery/LimparErrosFoody",
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return {
                    data: erroParaRespostaRaw(error) as { codErro?: number; mensagem?: string },
                }
            })

        const d = response.data
        if (d && typeof d === "object" && d.codErro !== undefined && d.codErro > 0) {
            return { retornoErro: d.codErro, mensagem: d.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "LimparErrosFoody", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
